import React, {useState} from 'react';
import type {Property} from 'csstype';
import type {IconName} from '../icons/types';
import {AreYouSureDialog} from '../dialog/AreYouSureDialog';
import {ToolButton} from './ToolButton';

type Props = {
  title: string;
  onConfirm: () => void;
  iconOnly?: boolean;
  icon?: IconName;
  doubleConfirm?: boolean;
  doubleConfirmMessage?: string;
  width?: Property.Width;
  prevent?: string;
};

export const ConfirmButton: React.FC<Props> = ({
  title,
  onConfirm,
  icon,
  iconOnly,
  doubleConfirm,
  doubleConfirmMessage,
  width,
  prevent,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpenConfirmation = () => {
    setOpen(true);
  };

  const handleCloseConfirmation = (confirmed?: boolean) => {
    setOpen(false);

    if (confirmed) {
      onConfirm();
    }
  };

  return (
    <>
      <ToolButton
        title={title}
        icon={icon}
        onClick={handleOpenConfirmation}
        iconOnly={iconOnly}
        width={width}
      />
      <AreYouSureDialog
        id="confirm-dialog"
        keepMounted={false}
        open={open}
        onClose={handleCloseConfirmation}
        doubleConfirm={doubleConfirm}
        doubleConfirmMessage={doubleConfirmMessage}
        prevent={prevent}
      />
    </>
  );
};
